<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'

// 資料
const plans = ref([
  { name: '加入代理', price: 500 },
  { name: '加入二階代理', price: 100 },
  { name: '月繳租用', price: 900 },
  { name: '季繳租用', price: 850 * 3, note: '節省150元' },
  { name: '年繳租用', price: 800 * 12, note: '節省1200元' }
])


function confirmPurchase (){

}
// 預設選擇「年繳租用」
const selectedPlan = ref(plans.value[4])

// 勾選框與合約條款相關變數
const agreed = ref(false)
const contractAgreed = ref(false) // 用來判斷合約是否勾選
const contractArea = ref<HTMLElement | null>(null) // 交易合約區域引用

// 滾動監聽
const handleScroll = () => {
  if (contractArea.value) {
    const contractElement = contractArea.value
    // 檢查滾動條是否已經到達底部
    const isScrolledToBottom = contractElement.scrollHeight - contractElement.scrollTop === contractElement.clientHeight
    contractAgreed.value = isScrolledToBottom // 滾動到底部時勾選同意
  }
}

onMounted(() => {
  nextTick(() => {
    // 確保 DOM 渲染後再添加滾動事件監聽
    if (contractArea.value) {
      contractArea.value.addEventListener('scroll', handleScroll)
    }
  })
})
</script>

<template>
  <div class="pay">
    <h1>支付</h1>

    <!-- 下拉選單 -->
    <div class="plan-select">
      <label for="plan-select">選擇計劃</label>
      <select v-model="selectedPlan" id="plan-select" style="width: 100%; padding: 10px; font-size: 16px;">
        <option v-for="(plan, index) in plans" :key="index" :value="plan">
          {{ plan.name }} - NT$ {{ plan.price }}
          <span v-if="plan.note">（{{ plan.note }}）</span>
        </option>
      </select>
    </div>

    <!-- 同意條款的勾選框 -->
    <div class="agreement">
      <label>
        <input type="checkbox" v-model="agreed" />
        我同意使用條款
      </label>
    </div>

    <!-- 交易合約 -->
    <div
      class="contract"
      ref="contractArea" 
      style="overflow-y: auto; max-height: 200px; background-color: #f5f5f5; border: 1px solid #ccc; padding: 10px;"
    >
      <textarea readonly style="width: 100%; height: 100%; background: transparent; border: none; resize: none;">
        這是交易合約的內容，請滾動到底部來查看完整合約條款。
        [在此加入合約內容]
      </textarea>
    </div>

    <!-- 確認按鈕 -->
    <button
      :disabled="!contractAgreed || !agreed"
      @click="confirmPurchase"
      style="margin-top: 20px; padding: 10px 20px; background-color: #4caf50; color: white; border: none; cursor: pointer; font-size: 16px;"
    >
      確認
    </button>
    <button>暫緩作業</button>
  </div>
</template>

<style scoped>
.pay {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
}

.plan-select {
  width: 100%;
  margin-bottom: 20px;
}

.agreement {
  margin-top: 15px;
}

.contract {
  width: 100%;
  height: 200px; /* 設定高度以讓它能滾動 */
  overflow-y: auto; /* 使內容可滾動 */
  margin-top: 15px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  padding: 10px;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}
</style>
